"use client";

import { routes } from "@/lib/routes";
import { Button } from "@workspace/ui/components/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@workspace/ui/components/popover";
import { ChevronRight } from "lucide-react";
import Link from "next/link";
import { ReactNode } from "react";

interface LoginPromptPopoverProps {
  children: ReactNode;
  message?: string;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export function LoginPromptPopover({
  children,
  message = "Please login to complete this action",
  open,
  onOpenChange,
}: LoginPromptPopoverProps) {
  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent
        className="bg-cream-50/90 w-80"
        side="top"
        sideOffset={8}
        glassOverlay
      >
        <div className="flex items-center gap-4">
          <div className="space-y-1">
            <h4 className="text-sm font-medium">Login Required</h4>
            <p className="text-muted-foreground text-sm">{message}</p>
          </div>
          <Button
            asChild
            size="sm"
            className="bg-brand-200 text-brand-800 hover:bg-brand-300 size-10 rounded-full"
          >
            <Link href={routes.auth.signInWithRedirect(window.location.href)}>
              <ChevronRight className="h-4 w-4" />
              <div className="sr-only">Login</div>
            </Link>
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
